import React from 'react';
// import { Typography } from '@mui/material';
// import ExploreRoundedIcon from '@mui/icons-material/ExploreRounded';
// import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
// import AlternateEmailRoundedIcon from '@mui/icons-material/AlternateEmailRounded';
import Grid from '@mui/material/Grid';
import TypoBlock from './TypoBlock';
import PrettyLink from './PrettyLink';

export default function Pied() {

  return (
    <TypoBlock>
      <Grid
        container 
        direction="row"
        // justify="center"
        alignItems="stretch"
        // spacing={2}
      >
        <Grid item xs={12} sm={6}>
          <p>
            Hébergement: <PrettyLink target='_blank' rel='noreferrer' href='https://gitlab.com'>gitlab.com</PrettyLink>
          </p>
          <p>
            Domaine: <PrettyLink target='_blank' rel='noreferrer' href='https://ovh.com'>ovh.com</PrettyLink>
          </p>
          <p>
            SIRET: 90085234400010
          </p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <p>
            <PrettyLink target='_blank' rel='noreferrer' href='https://www.legeste-graphoformations.com/index.php'>Le Geste, Centre de formation</PrettyLink>
          </p>
        </Grid>
      </Grid>
    </TypoBlock>
  );
}
